(function() {
  function render() {
    var container = document.querySelector('[data-recently-viewed]');
    if (!container) return;
    var handles = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    if (!handles.length) {
      container.style.display = 'none';
      return;
    }
    var list = container.querySelector('[data-recently-viewed-list]');
    handles.forEach(function(handle) {
      fetch('/products/' + handle + '?view=card-product')
        .then(function(res) { return res.text(); })
        .then(function(html) {
          list.insertAdjacentHTML('beforeend', '<li class="grid__item">' + html + '</li>');
        });
    });
  }
  document.addEventListener('DOMContentLoaded', render);
})();
